var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"environment-widget"},[(_vm.environment === 'development')?_c('div',{staticClass:"widget-content"},[_vm._v(" Development ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }